// Chart Calculations
import "./js/calc";

// Tooltips
import "./js/tooltips";

// Post styles
import "./ficalc.scss";
